var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgAlert = function SvgAlert(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 24,
    viewBox: "0 0 22 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.805 7.924C21.675 6.696 20.771 5.097 19.793 4.368C19.793 4.368 18.333 3.281 16.5 2.2C14.666 1.12 13.013 0.375 13.013 0.375C11.905 -0.125 10.095 -0.125 8.988 0.375C8.988 0.375 7.334 1.121 5.5 2.2C3.666 3.28 2.206 4.368 2.206 4.368C1.228 5.098 0.323 6.696 0.193 7.924C0.193 7.924 0 9.758 0 11.918C0 14.078 0.193 15.912 0.193 15.912C0.323 17.14 1.228 18.739 2.205 19.467C2.205 19.467 3.665 20.555 5.5 21.637C7.334 22.717 8.988 23.463 8.988 23.463C10.095 23.961 11.905 23.961 13.013 23.463C13.013 23.463 14.666 22.717 16.5 21.636C18.334 20.556 19.794 19.466 19.794 19.466C20.772 18.739 21.676 17.14 21.806 15.912C21.806 15.912 22 14.079 22 11.918C22 9.758 21.806 7.924 21.806 7.924H21.805ZM9.999 15.83H11.999V17.814H9.999V15.83ZM9.999 6.022H11.999V13.886H9.999V6.022Z",
    fill: "#F2C94C"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAlert, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/alert.266f76f3.svg";
export { ForwardRef as ReactComponent };